import DescriptionTwoToneIcon from '@material-ui/icons/DescriptionTwoTone'
import ImageTwoToneIcon from '@material-ui/icons/ImageTwoTone'
import PlayCircleOutlineTwoToneIcon from '@material-ui/icons/PlayCircleOutlineTwoTone'
import LinkTwoToneIcon from '@material-ui/icons/LinkTwoTone'

export const CONTENT_ASSET_TYPE = {
	DOCUMENT: 1,
	IMAGE: 2,
	VIDEO: 3,
	LINK: 4
}

const TYPE_ICON_MAP = {
	[CONTENT_ASSET_TYPE.DOCUMENT]: DescriptionTwoToneIcon,
	[CONTENT_ASSET_TYPE.IMAGE]: ImageTwoToneIcon,
	[CONTENT_ASSET_TYPE.VIDEO]: PlayCircleOutlineTwoToneIcon,
	[CONTENT_ASSET_TYPE.LINK]: LinkTwoToneIcon
}

const TYPE_LABEL_MAP = {
	[CONTENT_ASSET_TYPE.DOCUMENT]: 'Document',
	[CONTENT_ASSET_TYPE.IMAGE]: 'Image',
	[CONTENT_ASSET_TYPE.VIDEO]: 'Video',
	[CONTENT_ASSET_TYPE.LINK]: 'Link'
}

export const getTypeIcon = (type) => TYPE_ICON_MAP[type] || DescriptionTwoToneIcon
export const getTypeLabel = (type) => TYPE_LABEL_MAP[type] || 'Resource'

/**
 * Returns the subtitle string shown below the title in both the list row and
 * the card. For non-link assets: `"{TypeLabel} · {OriginalFilename}"`.
 * For link assets: `"{TypeLabel} · {hostname}"` extracted from `ExternalUrl`.
 */
export const getAssetSubtitle = (item) => {
	if (!item) return ''
	const label = getTypeLabel(item.Type)
	if (item.Type === CONTENT_ASSET_TYPE.LINK) {
		const host = safeHostname(item.ExternalUrl)
		return host ? `${label} · ${host}` : label
	}
	return item.OriginalFilename ? `${label} · ${item.OriginalFilename}` : label
}

const safeHostname = (url) => {
	if (!url) return null
	try {
		return new URL(url).hostname
	} catch (_) {
		return null
	}
}
